import React from 'react';
import useActiveCampaignForm from '../../hooks/useActiveCampaignForm';

const ActiveCampaignForm = ({
  id,
  formId,
  className = '',
  disabled = false,
}) => {
  useActiveCampaignForm({
    formId,
    disabled,
  });

  return (
    <div className={`active-campaign-form ${className}`}>
      <div
        className={`_form_${formId}`}
        id={id ? id : `ac-form-${formId}`}
      ></div>
    </div>
  );
};

export default ActiveCampaignForm;
